export const sidebarOptions = [
  "Overview",
  "Financing",
  "Team",
  "Market",
  "Product & Services",
  "Similar Companies"
  // "Metrics"
];

export const sidebarRestrictedOptions = [
  "Team",
  "Market",
  "Product & Services",
  "Similar Companies"
  // "Metrics"
];

export enum ESectionOptions {
  OVERVIEW = "Overview",
  FINANCING = "Financing",
  TEAM = "Team",
  MARKET = "Market",
  PRODUCTS_AND_SERVICES = "Product & Services",
  COMPETITIVE_LANDSCAPE = "Similar Companies"
}
